import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Route, Switch} from "react-router-dom";
import {applyMiddleware,createStore} from 'redux';
import {Provider} from 'react-redux';
import thunk from 'redux-thunk'
import combinedReducers from './all-reducers';
import AgreementContainer  from "./company/containers/get-agreement";
import DisplayDetailsContainer  from './company/containers/display-details';
import SubmitCompanyInfo from './company/components/submit-company-info';
import SupplierSummary from './company/components/supplier-summary';
import CreateCommodityContainer from './commodities-services/containers/create-commodity';
import LoginScreen from './login/LoginScreen';
import DiversityFinacialInfo from './diversity-finacial/diversity-finacial-component';
import InternalLogin from './login/InternalLogin';
import Deeresummary from './company/components/deere-summary'
import ErrorPage from "./reusable/ErrorPage";

const store = createStore(combinedReducers, applyMiddleware(thunk));
render( 
  <Provider store={store}>
    <BrowserRouter>     
      <Switch>
        <Route exact path={"/"} component={AgreementContainer} />
        <Route path={"/supplier-details/:value"} exact component={DisplayDetailsContainer} />
        <Route path={"/supplier-submit/:value"} exact component={SubmitCompanyInfo} />        
        <Route path={"/login"} exact component={LoginScreen} />
        <Route path={"/supplier-summary/:value"} exact component={SupplierSummary} />
        <Route path={"/deere-summary/:value1/:value2"} exact component={Deeresummary} />        
        <Route path={"/diversity-finacial-info/:value"} exact component={DiversityFinacialInfo} />
        <Route path={"/commodity-info/:value"} exact component={CreateCommodityContainer} />
        <Route path={"/internal-login/:value1"} exact component={InternalLogin} />
        <Route path={"/internal-login/:value1/:value2"} exact component={InternalLogin} />
        <Route path={"/error"} exact component={ErrorPage}/>
      </Switch>  
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);